export const failure = {
	methods: {
		handleFailure(failure) {
			// console.log(failure);
			let msg = failure.body.message || "Something went wrong, please try again";
			let errors = failure.body.errors;
			if (errors && errors.Name) {
				msg = errors.Name;
			}
			if (errors && errors.Email) {
				msg = errors.Email;
			}
			this.$store.commit("showSnackbar", {
				timeout: 3000,
				message: msg,
				color: "error"
			});
		}
	}
};

export const pagination = {
	computed: {
		limit() {
			switch (this.$vuetify.breakpoint.name) {
				case "sm": return 9;
				case "xl": return 18;
				default: return 12;
			}
		}
	}
};

// Builds a CSV in the browser from data already loaded, so read-only tables can
// be exported without an extra round trip.
export const csvDownload = {
	methods: {
		downloadCsv(fileName, headers, rows) {
			const cell = (value) => {
				let text = value === null || value === undefined ? "" : String(value);
				// Excel and Sheets evaluate a cell opening with any of these, so a
				// name like =HYPERLINK(...) would run on open. Quoting does not stop
				// it; a leading apostrophe does.
				if (/^[=+\-@\t\r]/.test(text)) {
					text = `'${text}`;
				}
				return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, "\"\"")}"` : text;
			};
			const csv = [headers, ...rows]
				.map((row) => row.map(cell).join(","))
				.join("\n");

			// BOM keeps Excel from mangling non-ASCII names
			const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.download = `${String(fileName).replace(/[^\w.-]+/g, "_")}.csv`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			// the download reads the URL asynchronously, so revoking it in this tick
			// aborts the save in some browsers
			setTimeout(() => window.URL.revokeObjectURL(url), 0);
		}
	}
};